module.exports = __webpack_public_path__ + "media/images/countryrect/ag-cf7a71dc945a6034420f182cb7fef34c.svg";